export default __webpack_public_path__ + "static/media/copyright.02714bd2.webp";